import actionTypes from '../../../redux/actions/action-types';

export const getMembersAction = (data) => ({
  type: actionTypes.teamMembersPage.getMembers,
  data,
});

export const getDivisionMembersAction = (data) => ({
  type: actionTypes.teamMembersPage.getDivisionMembers,
  data,
});

export const updateUsersGroupAction = (data) => ({
  type: actionTypes.teamMembersPage.updateUsersGroup,
  data,
});

export const updateDivisionMembersAction = (data) => ({
  type: actionTypes.teamMembersPage.updateDivisionMembers,
  data,
});

export const deleteTeamUsersAction = (data) => ({
  type: actionTypes.teamMembersPage.deleteTeamUsers,
  data,
});

export const setAction = (data) => ({
  type: actionTypes.teamMembersPage.set,
  data,
});
